import "./Card_design.css";
import Chart from "./Chart";

export function Card_design({
  title,
  total_count,
  percentage,
  correct_count,
  trend_direction,
  trend_change,
  expanded,
  onExpand,
  onClose,
}) {
  return (
    <div
      className={`card_design_section ${expanded ? "expanded" : ""} ${
        trend_direction === "improving"
          ? "trend_improving"
          : trend_direction === "weakening"
            ? "trend_weakening"
            : "trend_stable"
      }`}
    >
      {/* =====================================================
          NORMAL CARD
      ===================================================== */}

      {!expanded && (
        <>
          <div className="card_design_header">
            <span className="card_design_title">{title}</span>

            <button className="expand_btn" onClick={onExpand}>
              EXPAND
            </button>
          </div>

          <div className="card_design_body">
            <div className="card_stat">
              <span className="card_stat_label">Matches</span>

              <strong>
                {correct_count}/{total_count}
              </strong>
            </div>

            <div className="card_stat">
              <span className="card_stat_label">Accuracy</span>

              <strong>{percentage}%</strong>
            </div>

            <div className="card_stat">
              <span className="card_stat_label">Trend</span>

              <strong className={`trend_value ${trend_direction}`}>
                {trend_direction === "improving" && "↑"}
                {trend_direction === "weakening" && "↓"}
                {trend_direction === "stable" && "→"} {trend_change}%
              </strong>
            </div>
          </div>
        </>
      )}

      {/* =====================================================
          EXPANDED CARD
      ===================================================== */}

      {expanded && (
        <div className="card_design_expanded">
          {/* FLOATING CLOSE BUTTON */}

          <button
            className="expanded_close_btn"
            onClick={onClose}
            title="Close"
          >
            ×
          </button>

          {/* EXPANDED HEADER */}

          <div className="expanded_card_header">
            <div>
              <span className="expanded_card_title">{title}</span>

              <span className="expanded_card_subtitle">
                Algorithm performance details
              </span>
            </div>

            <div className="expanded_card_stats">
              <div>
                <span>Accuracy</span>
                <strong>{percentage}%</strong>
              </div>

              <div>
                <span>Matches</span>
                <strong>
                  {correct_count}/{total_count}
                </strong>
              </div>

              <div>
                <span>Trend</span>
                <strong className={`trend_value ${trend_direction}`}>
                  {trend_direction === "improving" && "↑"}
                  {trend_direction === "weakening" && "↓"}
                  {trend_direction === "stable" && "→"} {trend_change}%
                </strong>
              </div>
            </div>
          </div>

          {/* CHART */}

          <div className="expanded_chart_container">
            <Chart title={title} />
          </div>
        </div>
      )}
    </div>
  );
}
